import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import OrderCardBuilderTabContent from "./OrderCardBuilderTabContent";
import Tabs from "../Tabs/Tabs";
import { parseISO } from 'date-fns'
import ErrorHelper from "../Errors/ErrorHelper";

export default class OrderCardBuilder extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      active_tab: 'general',
      order: {
        status: this.props.order.status,
        customer: this.props.order.customer,
      },
      note_obj: this.props.note || {
        note: null,
        notable_type: null,
        notable_id: null,
        flagged: false,
        user: null,
        created_at: null,
        updated_at: null
      },
      file_upload_group: this.props.file_upload_group,
      calculate_children_data_table_path: this.props.calculate_children_data_table_path,
      order_revision_history_path: this.props.order_revision_history_path,
      read_only: this.props.read_only,
      item_type: this.props.folio_item_type_name || null,
      errors: [],
      loading: false,
    };
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.onChangeOrder = this.onChangeOrder.bind(this);
  }

  render() {
    var self = this;
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: function (e) {
          e.stopPropagation()
          e.preventDefault()

          self.onSave()
        }
      }
    ];

    return (
      <div className="order-builder">
        <div className="panel panel-form">
          <Tabs tabs={this.tabs()}/>
            
          <ModalButtons loading={this.state.loading} buttons={buttons} />

          <OrderCardBuilderTabContent
            {...this.props}
            {...this.state}
            onChangeOrder={this.onChangeOrder}
            buttons={buttons}
          />
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  tabs() {
    var tabs = [];

    tabs.push({
      tabName: I18n.t("general"),
      targetName: "general",
      classes: this.state.active_tab === "general" ? "active" : null,
      changeHandler: this.onChangeActiveTab,
      tabErrorCount: ErrorHelper.tabErrorCount(this.state.errors, ['scheduled_at', 'customer']),
    })

    tabs.push({
      tabName: I18n.t("folios"),
      targetName: "folios",
      classes: this.state.active_tab === "folios" ? "active" : null,
      changeHandler: this.onChangeActiveTab,
    })

    if (!this.state.new_record) {
      tabs.push({
        tabName: I18n.t("emails"),
        targetName: "emails",
        classes: this.state.active_tab === "emails" ? "active" : null,
        changeHandler: this.onChangeActiveTab,
      });
    }

    tabs.push({
      tabName: I18n.t("notes"),
      targetName: "notes",
      classes: this.state.active_tab === "notes" ? "active" : null,
      changeHandler: this.onChangeActiveTab,
      labelCount: this.state.note_count,
    })

    if (!this.state.new_record) {
      tabs.push({
        tabName: I18n.t("system_notifications"),
        targetName: "system_notifications",
        classes: this.state.active_tab === "system_notifications" ? "active" : null,
        changeHandler: this.onChangeActiveTab,
      })
    }

    if (this.props.read_only) {
      tabs.push({
        tabName: I18n.t('history'),
        targetName: 'history',
        classes: this.state.active_tab === 'history' ? 'active' : null,
        changeHandler: this.onChangeActiveTab,
      })
    }

    return tabs;
  }

  /*
   * Change handlers
   */

  onChangeActiveTab(active_tab) {
    this.setState({
      active_tab: active_tab,
    });
  }

  onChangeOrder(e) {
    let order = Object.assign({}, this.state.order)
    order[e.target.name] = e.target.value
    this.setState({
      order: order,
    })
  }

  onChangeFileUploadGroup(file_upload_group) {
    this.setState({file_upload_group: file_upload_group});
  }

  onChangeNote(noteText) {
    if (noteText) {
      var note_obj = Object.assign({}, this.state.note_obj)
      note_obj.note = noteText

      this.setState({
        note_obj: note_obj
      })
    }
  }

  onChangeFlagged(event) {
    var note_obj = this.state.note_obj;
    note_obj['flagged'] = event.target.checked
    this.setState({note_obj: note_obj, flagged: event.target.checked});
  }

  onSave() {
    this.setState({ loading: true })
    var data = this.prepParams();
    $.ajax({
      type: this.state.new_record ? "POST" : "PATCH",
      url: this.state.new_record
        ? this.props.order_create_path
        : this.props.order_save_path,
      data: data
    }).done((data) => {
      this.setState({ loading: false })
      if (data.errors && Object.keys(data.errors).length > 0) {
        this.setState({
          errors: data.errors,
        });
      } else {
        if (parent && parent.refresh_data) {
          if (this.state.new_record == true) {
            parent.refresh_data(I18n.t('order_created_successfully'));
          } else {
            parent.refresh_data(I18n.t('order_saved_successfully'));
          }
        }
  
        if (parent && parent.hide_modal) {
          parent.hide_modal()
        }
      }
    }).catch((data) => {
      if (data && data.responseJSON) {
        this.setState({ errors: data.responseJSON, loading: false })
        $('.modal-body').scrollTop(0)
      }
    })
  }

  prepParams() {
    return {
      order: {
        status_event: this.state.order.status == 'submitted' ? 'submit'
          : this.state.order.status == 'completed' ? 'complete'
            : this.state.order.status == 'canceled' ? 'cancel'
              : null,
        customer_id: this.state.order.customer ? this.state.order.customer.id : null,
      },
    };
  }
}
